import { useTranslations } from "next-intl";

import { getCountryConfigMap } from "@/config/country.config";
import { useCountryStore } from "@/store/country.store";
import { SelectValue } from "@/types/select.types";
import { HeadTitle } from "@/ui/Common/HeadTitle/index";
import Select from "@/ui/Common/Select";
import { HandleChangeValue } from "@/ui/Common/SelectList";
import { cn } from "@/utils/cn";

import styles from "./style.module.scss";

type List = (obj: SelectValue[], t: any) => SelectValue[];

const countryListValue: List = (obj, t) =>
  obj.map(({ value, label, icon }) => ({
    value,
    label: t(label),
    icon,
  }));

export const CountrySearch = () => {
  const t = useTranslations();
  const { country, countryList, setCounty } = useCountryStore();

  const handleChange = (val: HandleChangeValue) => {
    setCounty(val.value);
  };

  return (
    <div className={styles.wrapper}>
      <HeadTitle title={t("Select the country of search")} />
      <p className={cn(styles.title)}>
        {t(
          "We suggest you choose the country of search where you will look for real estate! You can change these options after selection",
        )}
      </p>
      <Select
        current={t(country.label)}
        list={countryListValue(countryList, t)}
        handleChange={handleChange}
        withListIcon
        headIcon={getCountryConfigMap().get(country.label)?.icon}
        withSearch
        alwaysOpen
        style={{
          width: "100%",
          height: "4.8rem",
          color: "rgba(77, 77, 77, 0.6)",
          fontWeight: "500",
        }}
      />
    </div>
  );
};
